import { Asset } from 'src/app/core/models/asset.model';
import { Customer } from 'src/app/core/models/customer.model';
import { DataType } from 'src/app/core/models/data-type.model';
import { NodeType } from 'src/app/core/models/node-type.model';
import { Node } from 'src/app/core/models/node.model';
import { Reference } from 'src/app/core/models/reference.model';
import { TreeNode } from 'src/app/core/models/tree-node.model';
import { User } from 'src/app/core/models/user.model';

export interface DataNodes {
	[key: number]: TreeNode;
}

export interface StaticData {
	dataTypes: DataType[];
	nodeTypes: NodeType[];
	assets: Asset[];
	references: Reference[];
	nodes: Node[];
}

export interface AppStateModel {
	user: User;
	customer: Customer;
	staticData: StaticData;
	// nodeTree: TreeNode[];
	// activeNode: TreeNode;
	// dataNodes?: { [key: number]: TreeNode; };
}

export const initialState: AppStateModel = {
	user: null,
	customer: null,
	staticData: {
		dataTypes: [],
		nodeTypes: [],
		assets: [],
		references: [],
		nodes: null,
	},
	// nodeTree: null,
	// activeNode: null,
};
